const gameFormHeaderStyles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '18px 24px 16px',
    borderBottom: '1px solid #ECECEC',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
  },
  iconChip: {
    width: 14,
    height: 14,
    borderRadius: 3,
    backgroundColor: '#A8D65C',
    flexShrink: 0,
  },
  title: {
    marginLeft: 10,
    fontSize: 22,
    fontWeight: 500,
    color: '#3C3C3C',
    lineHeight: 1.2,
  },
  closeButton: {
    marginLeft: 'auto',
    width: 34,
    height: 34,
    color: '#6E6E6E',
    '&:hover': {
      backgroundColor: '#F2F2F2',
    },
  },
  subtitle: {
    marginLeft: 24,
    marginTop: 2,
    fontSize: 13,
    color: '#9A9A9A',
  },
  separator: {
    margin: '0 6px',
    color: '#C4C4C4',
  },
})

export default gameFormHeaderStyles
